import React from "react";
import {
  Bar,
  Icon,
  IconsWrapper,
  Logo,
  LogoWrapper,
} from "./Appbar.style";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";
import {
  SearchOutlined,
  DownloadOutlined,
  MessageOutlined,
} from "@assets";

const Appbar = () => {
  const navigate = useNavigate();
  const goToSearch = () => {
    navigate(`/${PUBLIC_ROUTE.SEARCH}`);
  }

  const goToDownload = () => {
    navigate(`/${PUBLIC_ROUTE.APP_DOWNLOAD}`);
  }

  const goToMessages = () => {
    navigate(`/${PUBLIC_ROUTE.MESSAGE}`);
  }

  return (
    <Bar>
      <LogoWrapper>
        <Logo />
      </LogoWrapper>
      <IconsWrapper>
        <Icon onClick={goToMessages}>
          <MessageOutlined />
        </Icon>

        <Icon onClick={goToSearch} >
          <SearchOutlined />
        </Icon>

        <Icon onClick={goToDownload}>
          <DownloadOutlined />
        </Icon>
      </IconsWrapper>
    </Bar>
  );
};

export default Appbar;
